/**
 * An array of buffered arguments to send to Google Analytics.
 * @type {Array}
 */
const bufferedArguments = []

/**
 * The amount of retries left before giving up on the Google Analytics script loading.
 * @type {number}
 */
let retriesLeft = 10

/**
 * Tracks a pageview for the given path.
 * @param {string} path
 */
export function trackPageView(path) {
  sendToGoogleAnalytics('send', {
    hitType: 'pageview',
    page: path,
    location: `${location.protocol}//${location.hostname}${path}`,
  })
}

/**
 * Sends the given arguments to Google Analytics.
 *
 * This function (together with `sendBufferedArguments`) wraps over the `ga` function provided by Google,
 * but handles errors if the `ga` script hasn't loaded and handles queuing of calls if necessary.
 */
export function sendToGoogleAnalytics() {
  bufferedArguments.push(arguments)
  sendBufferedArguments()
}

/**
 * Tries to send everything from the array of buffered arguments to Google Analytics.
 * Will try again up to 10 times before giving up.
 * As soon a set of requests is successfully sent the retry count is reset to 10.
 */
function sendBufferedArguments() {
  try {
    bufferedArguments.forEach(args => {
      ga(...args)
    })
    bufferedArguments.length = 0

    // Reset the amount of retries
    retriesLeft = 10
  } catch (err) {
    if (retriesLeft-- < 0) {
      setTimeout(() => {
        sendBufferedArguments()
      }, 500)
    }
  }
}
